const requestQuote = {
  hero: {
    title: "Κλείστε δωρεάν συμβουλευτική",
    description:
      "Συμπληρώστε τη φόρμα και η ομάδα μας θα επικοινωνήσει μαζί σας το συντομότερο δυνατό για επιβεβαίωση.",
  },
  form: {
    title: "Φόρμα ενδιαφέροντος",
  },
  call: {
    prefix: "Προτιμάτε να μας καλέσετε;",
  },
};

export default requestQuote;

